import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "对比榜单", to: "/bang" },
  { label: "关于我们", to: "/about" },
  { label: "联系反馈", to: "/contact" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/bang?q=${encodeURIComponent(value)}` : "/bang");
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="flex h-16 w-full items-center gap-6 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex shrink-0 cursor-pointer items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-article-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              反差档案
            </span>
            <span className="mt-0.5 hidden text-[10px] tracking-[0.22em] text-foreground-500 sm:block">
              FANCHA ARCHIVE
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden flex-1 items-center gap-1 lg:flex">
          {navItems.map((item) => {
            const active =
              item.to === "/" ? location.pathname === "/" : location.pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`cursor-pointer rounded-md px-3.5 py-2 text-sm transition-colors ${
                  active
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <form
          onSubmit={submitSearch}
          role="search"
          className="ml-auto hidden w-64 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 md:flex"
        >
          <i className="ri-search-line text-base text-foreground-500"></i>
          <input
            type="search"
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="搜索博主 / 关键词"
            aria-label="搜索对比对象"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
          />
        </form>

        <Link
          to="/bang"
          className="ml-auto hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex lg:ml-0"
        >
          进入榜单
        </Link>

        <button
          type="button"
          aria-label="打开菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-900 lg:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 lg:hidden">
          <form
            onSubmit={submitSearch}
            role="search"
            className="mb-4 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2.5"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              type="search"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索博主 / 关键词"
              aria-label="搜索对比对象"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
            />
          </form>
          <nav aria-label="移动端导航" className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="cursor-pointer rounded-md px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-200"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}